import { axiosUtil as Api } from "../utils/axios";
import CONFIG from "../utils/config";

const defaultTime = 5000;
const endpoint = CONFIG.VUE_APP_SERVICE_VOUCHER_PRIVATE
const endpointPublic = CONFIG.VUE_APP_SERVICE_VOUCHER

export const VoucherApi = Object.freeze({
    getVoucherGenerate: (
        perPage,
        page,
        search,
        classroomCode,
    ) => Api.get(endpoint + '/voucher-generate/show-voucher-generate?per_page=' + perPage + '&page=' + page + '&search=' + search + '&classroom_code=' + (classroomCode || '')),

    detailVoucherGenerate: (
        id
    ) => Api.get(endpoint + '/voucher-generate/show/' + id),

    getUserVoucher: (
        uuid
    ) => Api.get(endpoint + '/voucher-classroom/user/' + uuid),

    addVoucherGenerate: (
        payload
    ) => {
        const res = Api.post(endpoint + '/voucher-generate/add', payload, { timeout: 120000 })
        return Promise.resolve(res)
    },

    updateVoucherGenerate: (
        id,
        payload
    ) => {
        const res = Api.put(endpoint + '/voucher-generate/update/' + id, payload)
        return Promise.resolve(res)
    },

    deleteVoucherGenerate: (
        id
    ) => {
        const res = Api.delete(endpoint + '/voucher-generate/delete/' + id)
        return Promise.resolve(res)
    },

    getVoucherClassrooms(page, perPage, uuid, code, classroomId) {
        try {
            let ep = endpoint + '/voucher-classroom/show-voucher-classroom?page=' + page + '&per_page=' + perPage
            if (uuid != '') {
                ep = ep + '&uuid=' + uuid
            }
            if (code != '') {
                ep = ep + '&code=' + code
            }
            if (classroomId != '' && classroomId > 0) {
                ep = ep + '&classroom_id=' + classroomId
            }
            const res = Api.get(ep)
            return Promise.resolve(res)
        } catch(err) {
            return Promise.reject(err)
        }
    },

    getCountVoucherClassrooms: () => Api.get(endpoint + '/voucher-classroom/count-voucher-classroom'),

    getSearchVoucherClassrooms: (
        code,
        store,
    ) => Api.get(endpoint + '/voucher-classroom/search-voucher?code=' + code + '&store=' + store),

    detailVoucherClassroom: id => Api.get(endpoint + '/voucher-classroom/show/' + id),

    getAllCoupon: (
        perPage,
        page,
        code,
    ) => {
        let url = endpoint + '/coupon/show-coupon?per_page=' + perPage + '&page=' + page
        if (code) {
            url = url + '&code=' + code
        }
        return Promise.resolve(Api.get(url))
    },

    detailCoupon: (
        id
    ) => Api.get(endpoint + '/coupon/show/' + id),

    addCoupon: (
        payload
    ) => {
        const data = {
                name: payload.name,
                code: payload.code,
                description: payload.description,
                short_description: payload.shortDescription,
                price: payload.price,
                percentage: payload.percentage,
                start_at: payload.startAt,
                end_at: payload.endAt,
                per_user_quota_day: parseInt(payload.perUserQuotaDay),
                per_user_quota: parseInt(payload.perUserQuota),
                minimum_bought: payload.minBought,
                is_active: payload.isActive,
                quota: parseInt(payload.quota),
                classes: payload.classes,
                minimum_item_match: parseInt(payload.minItemMatch),
            }
        if (data.percentage) {
            delete data.price
        } else {
            delete data.percentage
        }
            // console.log(data)
        const res = Api.post(endpoint + '/coupon/add', data, { timeout: defaultTime })
        return Promise.resolve(res)
    },

    updateCoupon: (
        id,
        payload,
    ) => {
        const data = {
            name: payload.name,
            code: payload.code,
            description: payload.description,
            short_description: payload.shortDescription,
            price: payload.price,
            percentage: payload.percentage,
            start_at: payload.startAt,
            end_at: payload.endAt,
            per_user_quota_day: parseInt(payload.perUserQuotaDay),
            per_user_quota: parseInt(payload.perUserQuota),
            minimum_bought: payload.minBought,
            is_active: payload.isActive,
            quota: parseInt(payload.quota),
            classes: payload.classes,
            minimum_item_match: parseInt(payload.minItemMatch),
        }
        if (data.percentage) {
            delete data.price
        } else {
            delete data.percentage
        }
        const res = Api.put(endpoint + '/coupon/update/' + id, data, { timeout: defaultTime })
        return Promise.resolve(res)
    },

    removeCoupon: (id) => {
        try {
            const res = Api.delete(endpoint + '/coupon/delete/' + id, {
                timeout: defaultTime
            })
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    // notification

    addPromotionNotification: (payload) => {
        const formData = new FormData()

        formData.append('content', payload.content)
        formData.append('short_description', payload.short_description)
        formData.append('thumbnail', payload.thumbnail)
        formData.append('slug', payload.slug)
        formData.append('title', payload.title)
        const res = Api.post(endpoint + '/promo', formData, { timeout: defaultTime })
        return Promise.resolve(res)
    },

    updatePromotionNotification: (id, payload) => {
        const formData = new FormData()

        formData.append('content', payload.content)
        formData.append('short_description', payload.short_description)
        formData.append('thumbnail', payload.thumbnail)
        formData.append('slug', payload.slug)
        formData.append('title', payload.title)

        const res = Api.put(endpoint + '/promo/' + id, formData, { timeout: defaultTime })
        return Promise.resolve(res)
    },

    getAllPromotionNotification: (

    ) => Api.get(endpoint + '/promo?per_page=-1&page=1', {
        timeout: defaultTime
    }),

    detailPromotionNotification: (id) => Api.get(endpoint + '/promo/' + id),
    blastPromotionNotification: (id, publishState) => {
        const res = Api.put(endpoint + '/promo/' + id + '/blast?publish=' + publishState, { timeout: defaultTime })
        return Promise.resolve(res)
    },
    removePromotionNotification: (id) => {
        try {

            const res = Api.delete(endpoint + '/promo/' + id, {
                timeout: defaultTime
            })
            return Promise.resolve(res)

        } catch (err) {
            return Promise.reject(err)
        }
    },

    redeemVoucher(uuid, code) {
      try {
        const payload = {
          uuid: uuid
        }
        const res = Api.put(endpointPublic + '/voucher-classroom/redeem-public/' + code, payload)
        return Promise.resolve(res)
      } catch (err) {
        return Promise.reject(err)
      }
    }

});